;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Router = APP.module('Router');

	Router.LoginForm = Router.LoginForm.extend({
		permissions: {
			'index': {
				'type': 2,
				'redirect_to': 'tipping'
			},
			'forgotPassword': {
				'type': 2,
				'redirect_to': 'tipping'
			},
			'passwordRecovery': {
				'type': 2,
				'redirect_to': 'tipping'
			}
		}
	});

}(window, APP, Backbone, Marionette, $, _));